module.exports = __webpack_public_path__ + "img/portrait-088.7d1e17ab.jpg";